module.exports = __webpack_public_path__ + "static/media/message-sent.b8d28cb2.svg";